<app-ui-modal
  [isOpen]="true"
  [title]="(isEditMode() ? 'NOUVEAUTES.MODAL_EDIT_TITLE' : 'NOUVEAUTES.MODAL_TITLE') | translate"
  (closed)="onClose()"
>
  <div class="m-nouveaute-form">
    <!-- Titre -->
    <div class="m-nouveaute-form__field">
      <label for="nouveaute-title" class="m-nouveaute-form__label">
        {{ 'NOUVEAUTES.FORM.TITLE_LABEL' | translate }}
        <span class="m-nouveaute-form__required">*</span>
      </label>
      <input
        id="nouveaute-title"
        type="text"
        class="m-nouveaute-form__input"
        [class.m-nouveaute-form__input--error]="submitAttempted() && errors().title"
        [placeholder]="'NOUVEAUTES.FORM.TITLE_PLACEHOLDER' | translate"
        [value]="formData().title"
        (input)="updateField('title', $any($event.target).value)"
      />
      @if (submitAttempted() && errors().title) {
        <span class="m-nouveaute-form__error">
          {{ 'NOUVEAUTES.FORM.ERRORS.' + errors().title | translate }}
        </span>
      }
    </div>

    <div class="m-nouveaute-form__row">
      <!-- Date de publication -->
      <div class="m-nouveaute-form__field">
        <label for="nouveaute-date" class="m-nouveaute-form__label">
          {{ 'NOUVEAUTES.FORM.DATE_LABEL' | translate }}
          <span class="m-nouveaute-form__required">*</span>
        </label>
        <input
          id="nouveaute-date"
          type="date"
          class="m-nouveaute-form__input"
          [class.m-nouveaute-form__input--error]="submitAttempted() && errors().publicationDate"
          [min]="today"
          [value]="formData().publicationDate"
          (input)="updateField('publicationDate', $any($event.target).value)"
        />
        @if (submitAttempted() && errors().publicationDate) {
          <span class="m-nouveaute-form__error">
            {{ 'NOUVEAUTES.FORM.ERRORS.' + errors().publicationDate | translate }}
          </span>
        }
      </div>

      <!-- Numéro de version (optionnel) -->
      <div class="m-nouveaute-form__field">
        <label for="nouveaute-version" class="m-nouveaute-form__label">
          {{ 'NOUVEAUTES.FORM.VERSION_LABEL' | translate }}
          <span class="m-nouveaute-form__optional">{{
            'NOUVEAUTES.FORM.OPTIONAL' | translate
          }}</span>
        </label>
        <input
          id="nouveaute-version"
          type="text"
          class="m-nouveaute-form__input"
          [placeholder]="'NOUVEAUTES.FORM.VERSION_PLACEHOLDER' | translate"
          [value]="formData().version"
          (input)="updateField('version', $any($event.target).value)"
        />
      </div>
    </div>

    <!-- Statut -->
    <div class="m-nouveaute-form__field">
      <span class="m-nouveaute-form__label">{{ 'NOUVEAUTES.FORM.STATUS_LABEL' | translate }}</span>
      <div class="m-nouveaute-form__toggle">
        <span
          class="m-nouveaute-form__toggleLabel"
          [class.m-nouveaute-form__toggleLabel--active]="formData().status === 'draft'"
        >
          {{ 'NOUVEAUTES.FORM.STATUS_DRAFT' | translate }}
        </span>
        <label class="m-toggle" aria-label="Statut de publication">
          <input
            type="checkbox"
            [checked]="formData().status === 'published'"
            (change)="toggleStatus()"
          />
          <span class="m-toggle__slider"></span>
        </label>
        <span
          class="m-nouveaute-form__toggleLabel"
          [class.m-nouveaute-form__toggleLabel--active]="formData().status === 'published'"
        >
          {{ 'NOUVEAUTES.FORM.STATUS_PUBLISHED' | translate }}
        </span>
      </div>
    </div>

    <!-- Contenu de la nouveauté -->
    <div class="m-nouveaute-form__contentBlock">
      <div class="m-nouveaute-form__contentHeader">
        <span class="m-nouveaute-form__contentTitle">
          {{ 'NOUVEAUTES.FORM.CONTENT_BLOCK_TITLE' | translate }}
          <span class="m-nouveaute-form__optional">{{
            'NOUVEAUTES.FORM.OPTIONAL' | translate
          }}</span>
        </span>
        <button type="button" class="m-nouveaute-form__addSectionBtn" (click)="addSection()">
          + {{ 'NOUVEAUTES.FORM.ADD_SECTION' | translate }}
        </button>
      </div>

      @for (section of formData().sections; track $index) {
        <div class="m-nouveaute-form__section">
          @if (formData().sections.length > 1) {
            <div class="m-nouveaute-form__sectionHeader">
              <span class="m-nouveaute-form__sectionIndex">Section {{ $index + 1 }}</span>
              <button
                type="button"
                class="m-nouveaute-form__removeBtn"
                (click)="removeSection($index)"
              >
                {{ 'NOUVEAUTES.FORM.REMOVE_SECTION' | translate }}
              </button>
            </div>
          }

          <!-- Titre de section -->
          <div class="m-nouveaute-form__field">
            <label [for]="'nouveaute-section-title-' + $index" class="m-nouveaute-form__label">
              {{ 'NOUVEAUTES.FORM.SECTION_TITLE_LABEL' | translate }}
            </label>
            <input
              [id]="'nouveaute-section-title-' + $index"
              type="text"
              class="m-nouveaute-form__input"
              [placeholder]="'NOUVEAUTES.FORM.SECTION_TITLE_PLACEHOLDER' | translate"
              [value]="section.sectionTitle"
              (input)="updateSection($index, 'sectionTitle', $any($event.target).value)"
            />
          </div>

          <!-- Texte Markdown -->
          <div class="m-nouveaute-form__field">
            <label [for]="'nouveaute-markdown-' + $index" class="m-nouveaute-form__label">
              {{ 'NOUVEAUTES.FORM.MARKDOWN_LABEL' | translate }}
            </label>
            <div class="m-nouveaute-form__markdownEditor">
              <div class="m-nouveaute-form__markdownEditor__toolbar">
                <button
                  type="button"
                  class="m-nouveaute-form__markdownEditor__toolbarBtn"
                  title="Gras"
                  (click)="applyMarkdownFormat(sectionTextarea, $index, 'bold')"
                >
                  <strong>B</strong>
                </button>
                <button
                  type="button"
                  class="m-nouveaute-form__markdownEditor__toolbarBtn"
                  title="Italique"
                  (click)="applyMarkdownFormat(sectionTextarea, $index, 'italic')"
                >
                  <em>I</em>
                </button>
                <button
                  type="button"
                  class="m-nouveaute-form__markdownEditor__toolbarBtn"
                  title="Souligné"
                  (click)="applyMarkdownFormat(sectionTextarea, $index, 'underline')"
                >
                  <u>U</u>
                </button>
                <button
                  type="button"
                  class="m-nouveaute-form__markdownEditor__toolbarBtn"
                  title="Lien"
                  (click)="applyMarkdownFormat(sectionTextarea, $index, 'link')"
                >
                  🔗
                </button>
              </div>
              <textarea
                #sectionTextarea
                [id]="'nouveaute-markdown-' + $index"
                class="m-nouveaute-form__markdownEditor__textarea"
                rows="5"
                [placeholder]="'NOUVEAUTES.FORM.MARKDOWN_PLACEHOLDER' | translate"
                [value]="section.markdownContent"
                (input)="updateSection($index, 'markdownContent', $any($event.target).value)"
              ></textarea>
            </div>
          </div>
          <!-- Image (optionnel) -->
          <div class="m-nouveaute-form__field">
            <label [for]="'nouveaute-image-' + $index" class="m-nouveaute-form__label">
              {{ 'NOUVEAUTES.FORM.IMAGE_LABEL' | translate }}
              <span class="m-nouveaute-form__optional">{{
                'NOUVEAUTES.FORM.OPTIONAL' | translate
              }}</span>
              <span class="m-nouveaute-form__fileRow">
                @if (sectionImages()[$index]) {
                  <label [for]="'nouveaute-image-remove-' + $index" class="m-nouveaute-form__removeBtn">
                    {{ 'NOUVEAUTES.FORM.IMAGE_REMOVE' | translate }}
                  </label>
                  <input
                    [id]="'nouveaute-image-remove-' + $index"
                    type="button"
                    class="m-nouveaute-form__removeInput"
                    (click)="onRemoveImage($index)"
                  />
                }
                <label [for]="'nouveaute-image-' + $index" class="m-nouveaute-form__fileBtn">
                  {{ 'NOUVEAUTES.FORM.IMAGE_BROWSE' | translate }}
                </label>
                <input
                  [id]="'nouveaute-image-' + $index"
                  type="file"
                  accept="image/*"
                  class="m-nouveaute-form__fileInput"
                  (change)="onImageChange($index, $event)"
                />
              </span>
            </label>
            <div class="m-nouveaute-form__imagePreview">
              @if (sectionImages()[$index]) {
                <img
                  [src]="sectionImages()[$index]"
                  [alt]="section.sectionTitle || 'Section Image'"
                  class="m-nouveaute-form__previewImage"
                />
              } @else {
                <span class="m-nouveaute-form__placeholderImagePreview">
                  @if (section.imageKey) {
                    <app-ui-spinner [size]="30" />
                  } @else {
                    {{'NOUVEAUTES.FORM.IMAGE_NO_FILE' | translate }}
                  }
                </span>
              }
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Actions -->
    <div class="m-nouveaute-form__actions">
      <button type="button" class="m-nouveaute-form__cancel" (click)="onClose()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      @if (isEditMode()) {
        <button type="button" class="m-nouveaute-form__delete" (click)="onDelete()">
          {{ 'COMMON.DELETE' | translate }}
        </button>
      }
      <button type="button" class="m-nouveaute-form__submit" (click)="onSubmit()">
        {{ (isEditMode() ? 'COMMON.SAVE' : 'COMMON.ADD') | translate }}
      </button>
    </div>
  </div>
</app-ui-modal>
